export const getQueryParamValue = (
  medication: string,
  selectedProduct: string
) => {
  if (selectedProduct === "Sildenafil") {
    return medication === "Sildenafil"
      ? "Boss+(Sildenafil)"
      : medication === "Tadalafil"
      ? "Boss+(Tadalafil)"
      : "Boss+(Sildenafil)";
  }

  return "Boss Max";
};
